var map = {
	"./gpic1.png": "2223",
	"./gpic10.png": "0ac4",
	"./gpic2.png": "838c",
	"./gpic3.png": "4352",
	"./gpic4.png": "ef83",
	"./gpic5.png": "90be",
	"./gpic6.png": "3adb",
	"./gpic7.png": "9da1",
	"./gpic8.png": "b12c",
	"./gpic9.png": "0fd1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72ba";